export const PATIENT_INFO_OBJECT = {
  apiParam: 'PatientInfo',
  id: '',
  createdBy: '',
  enabled: true,
  deleted: false,
  idByUser: false,
  createdTime: '',
  modifiedTime: '',
  modifiedBy: '',
  clinicBrandId: '',
  clinicId: '',
  mentorId: '',
  name: '',
  mobile: '',
  status: '',
  loginType: '',
  userId: '',
  pendingOn: '',
  dateOfBirth: '',
  gender: '',
}
